// extracted by mini-css-extract-plugin
export var copyableItem = "_h-0";
export var underlined = "_h-1";